import 'dayjs/locale/en'
import 'dayjs/locale/de'

import dayjs from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
import duration from 'dayjs/plugin/duration'
import isToday from 'dayjs/plugin/isToday'
import isTomorrow from 'dayjs/plugin/isTomorrow'
import updateLocale from 'dayjs/plugin/updateLocale'
import weekday from 'dayjs/plugin/weekday'

import i18n from '@/i18n'

dayjs.extend(isToday)
dayjs.extend(isTomorrow)
dayjs.extend(calendar)
dayjs.extend(duration)
dayjs.extend(weekday)
dayjs.extend(updateLocale)

dayjs.locale(i18n.global.locale.value)

dayjs.updateLocale(i18n.global.locale.value, {
  weekStart: 1,
})

export default dayjs
